import {
  resetProjectsComposerContextCore,
  useResetProjectsComposerContextCore,
} from '@heidi/agents/data';
import { clearLibraryDocumentPreview } from '@heidi/evidence';

type ResetArgs = Parameters<typeof resetProjectsComposerContextCore>;

/** Drop the Work-home / project composer linked chip and canvas artifact. */
export function resetProjectsComposerContext(
  store?: ResetArgs[1],
  persistedDraftProjectId?: ResetArgs[2],
  options?: ResetArgs[3]
): void {
  resetProjectsComposerContextCore(
    clearLibraryDocumentPreview,
    store,
    persistedDraftProjectId,
    options
  );
}

export function useResetProjectsComposerContext(): ReturnType<
  typeof useResetProjectsComposerContextCore
> {
  return useResetProjectsComposerContextCore(clearLibraryDocumentPreview);
}
